import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Router } from "react-router-dom";

import Firebase from "./contexto/Firebase";
import UsrLogged from "./contexto/UsrLogged";
import { createBrowserHistory } from "history";

export const AppContext = React.createContext({ firebase: new Firebase(), usrLogged: new UsrLogged() });
const customHistory = createBrowserHistory();

ReactDOM.render(
  <Router history={customHistory}>
    <App />
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
